import { render, staticRenderFns } from "./AppTopBarTab.vue?vue&type=template&id=a935940e&scoped=true"
import script from "./AppTopBarTab.vue?vue&type=script&lang=js"
export * from "./AppTopBarTab.vue?vue&type=script&lang=js"
import style0 from "./AppTopBarTab.vue?vue&type=style&index=0&id=a935940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935940e",
  null
  
)

export default component.exports